import logger from "../utils/logger";
import React, { useEffect } from "react";
import Icon from "./Icon";
import { supabase } from "../supabaseClient";

const ImpersonationBanner = () => {
  const adminReturnData = sessionStorage.getItem("admin_return_data");

  // Add padding to body when banner is shown
  useEffect(() => {
    if (adminReturnData) {
      document.body.style.paddingTop = "52px";
      return () => {
        document.body.style.paddingTop = "0px";
      };
    }
  }, [adminReturnData]);

  if (!adminReturnData) return null;

  const data = JSON.parse(adminReturnData);

  const handleReturnToAdmin = async () => {
    try {
      // Get stored admin session tokens
      const savedTokens = sessionStorage.getItem("admin_session_tokens");

      if (!savedTokens) {
        throw new Error("No admin session found to restore");
      }

      const tokens = JSON.parse(savedTokens);

      // Sign out the impersonated user
      await supabase.auth.signOut();

      // Restore admin session
      const { error } = await supabase.auth.setSession({
        access_token: tokens.access_token,
        refresh_token: tokens.refresh_token,
      });

      if (error) {
        throw error;
      }

      // Clear impersonation data
      sessionStorage.removeItem("admin_return_data");
      sessionStorage.removeItem("admin_session_tokens");
      sessionStorage.removeItem("impersonation_token");

      // Redirect to admin panel
      window.location.href = "/admin/user-management";
    } catch (error) {
      logger.error("Failed to restore admin session:", error);
      alert(
        "Failed to restore admin session. You will need to log in again.\n\n" +
        "Error: " + error.message
      );

      // Clear all impersonation data
      sessionStorage.removeItem("admin_return_data");
      sessionStorage.removeItem("admin_session_tokens");
      sessionStorage.removeItem("impersonation_token");

      // Sign out and redirect to login
      await supabase.auth.signOut();
      window.location.href = "/login";
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: "#7C3AED",
        color: "white",
        padding: "12px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Icon
        icon="heroicons:exclamation-triangle"
        style={{ width: "20px", height: "20px" }}
      />
      <p style={{ fontSize: "14px", fontWeight: "500", margin: 0 }}>
        You are viewing as: <strong>{data.impersonated_user_email}</strong>
        {" "}(Admin: {data.admin_email})
      </p>
      <button
        onClick={handleReturnToAdmin}
        style={{
          padding: "6px 16px",
          backgroundColor: "white",
          color: "#7C3AED",
          border: "none",
          borderRadius: "6px",
          fontSize: "13px",
          fontWeight: "600",
          cursor: "pointer",
          transition: "all 0.2s",
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = "#F3F4F6";
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = "white";
        }}
      >
        Return to Admin
      </button>
    </div>
  );
};

export default ImpersonationBanner;
